/*
 * Cor da marca por ambiente. develop e homologação têm VUE_APP_PRIMARY_COLOR próprio
 * (.env.develop / .env.homologacao); com ele a paleta da marca (cabeçalho, menu, botões,
 * tons suaves) muda de cor, para ficar claro em qual ambiente se está.
 * Produção usa o roxo padrão e continua exatamente como está (nada é sobrescrito).
 */
const COR_PADRAO = "#4f008f";
const BRANCO = "#ffffff";
const FUNDO_ESCURO = "#1c1a24"; // --surface do modo escuro (app.css)

function corDoAmbiente() {
  const cor = String(process.env.VUE_APP_PRIMARY_COLOR || COR_PADRAO)
    .trim()
    .toLowerCase();
  return /^#[0-9a-f]{6}$/.test(cor) ? cor : COR_PADRAO;
}

export function usaCorDoAmbiente() {
  return corDoAmbiente() !== COR_PADRAO;
}

/** Cor da barra do navegador (meta theme-color) no modo claro. */
export function corBarraClaro() {
  return corDoAmbiente();
}

/** Mistura `cor` com `alvo`; peso = quanto de `alvo` entra (0 a 1). */
function misturar(cor, alvo, peso) {
  const canal = (hex, i) => parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16);
  return `#${[0, 1, 2]
    .map((i) =>
      Math.round(canal(cor, i) * (1 - peso) + canal(alvo, i) * peso)
        .toString(16)
        .padStart(2, "0")
    )
    .join("")}`;
}

function regra(seletor, variaveis) {
  const corpo = Object.entries(variaveis)
    .map(([nome, valor]) => `  ${nome}: ${valor};`)
    .join("\n");
  return `${seletor} {\n${corpo}\n}`;
}

/** Aplica a paleta do ambiente (só em develop/homologação). Chamar antes de montar o app. */
export function aplicarCorAmbiente() {
  if (!usaCorDoAmbiente()) return;

  const cor = corDoAmbiente();
  const claro = {
    "--brand": cor,
    "--brand-2": misturar(cor, BRANCO, 0.15),
    "--brand-3": misturar(cor, BRANCO, 0.3),
    "--brand-soft": misturar(cor, BRANCO, 0.94),
    "--brand-soft-2": misturar(cor, BRANCO, 0.88),
    "--brand-border": misturar(cor, BRANCO, 0.8),
    "--surface-hover": misturar(cor, BRANCO, 0.94),
    "--input-bg": misturar(cor, BRANCO, 0.95),
    "--brand-grad-1": cor,
    "--brand-grad-2": misturar(cor, BRANCO, 0.15),
    "--brand-grad-3": misturar(cor, BRANCO, 0.3),
  };
  const escuro = {
    "--brand": misturar(cor, BRANCO, 0.45),
    "--brand-2": misturar(cor, BRANCO, 0.35),
    "--brand-3": misturar(cor, BRANCO, 0.25),
    "--brand-soft": misturar(cor, FUNDO_ESCURO, 0.8),
    "--brand-soft-2": misturar(cor, FUNDO_ESCURO, 0.72),
    "--brand-border": misturar(cor, FUNDO_ESCURO, 0.62),
    "--surface-hover": misturar(cor, FUNDO_ESCURO, 0.8),
  };

  // Seletores mais específicos que ":root" e "html.tema-escuro" do app.css.
  const estilo = document.createElement("style");
  estilo.id = "cor-ambiente";
  estilo.textContent = [
    regra(":root.cor-ambiente", claro),
    regra("html.tema-escuro.cor-ambiente", escuro),
  ].join("\n");
  document.head.appendChild(estilo);
  document.documentElement.classList.add("cor-ambiente");
}
